module.exports = __webpack_public_path__ + "static/media/alimentos3.3cf2a2a3.png";